module.exports = __webpack_public_path__ + "static/media/mcadam.d88bec39.png";